import { AgentRPCChannel } from "./AgentRPCChannel";
import { PublicStudentRulesDTO } from "../../../schools-backend/src/rule/application/stores/StudentRulesDTO";
import { WebTextInputDataDTO } from "../../../schools-backend/src/tracking/domain/WebTextInputDTO";
import { WebNavigationSessionDataDTO } from "../../../schools-backend/src/tracking/domain/WebNavigationSessionDTO";
import { DeviceStatusDTO } from "../../../schools-backend/src/student/application/dtos/StudentDeviceStatusDTO";
import { DesktopSnapshotDTO } from "../../../schools-backend/src/student/application/dtos/DesktopSnapshot";
import { YoutubeVideo } from "../../../schools-backend/src/filtering/youtube/application/stores/YoutubeVideo";
import { YoutubeChannel } from "../../../schools-backend/src/filtering/youtube/application/stores/YoutubeChannel";
import { WebCategoryRuleValueStoreEvaluationResult } from "../../../schools-backend/src/rule/application/stores/ruleValueStores/WebCategoryRuleValueStore";
import { YoutubeWatchSessionDataDTO } from "../../../schools-backend/src/tracking/domain/YoutubeWatchSessionDTO";

export class AgentServerAPI {
    private channel: AgentRPCChannel;

    constructor(channel: AgentRPCChannel) {
        this.channel = channel;
    }

    async getHealth(): Promise<boolean> {
        return await this.channel.call("health");
    }

    async getSessionId(): Promise<string> {
        const sessionId: string = await this.channel.call("get.session.id");
        return sessionId;
    }

    async getStudentRules(): Promise<PublicStudentRulesDTO> {
        const studentRulesDTO: PublicStudentRulesDTO = await this.channel.call("get.student.rules");
        return studentRulesDTO;
    }

    async getStudentDeviceStatus(): Promise<DeviceStatusDTO> {
        const deviceStatusDTO: DeviceStatusDTO = await this.channel.call("get.student.device.status");
        return deviceStatusDTO;
    }

    async updateDesktopSnapshot(desktopSnapshot: DesktopSnapshotDTO): Promise<void> {
        await this.channel.call("update.desktop.snapshot", desktopSnapshot);
    }

    async updateWatchedUrls(watchedUrls: string[]): Promise<void> {
        await this.channel.call("update.watched.urls", watchedUrls);
    }

    async queryUrlEvaluationByWebCategory(url: string): Promise<WebCategoryRuleValueStoreEvaluationResult> {
        const webCategoryEvaluationResult: WebCategoryRuleValueStoreEvaluationResult = (await this.channel.call(
            "query.url.evaluation.by.web.category",
            url,
        )) as WebCategoryRuleValueStoreEvaluationResult;
        return webCategoryEvaluationResult;
    }

    async getUploadUrlForTabScreenshot(tabId: number, screenshotId: string): Promise<string> {
        const uploadUrl: string = (await this.channel.call("get.upload.url.for.tab.screenshot", tabId, screenshotId)) as string;
        return uploadUrl;
    }

    async logWebTextInput(webTextInput: WebTextInputDataDTO): Promise<void> {
        await this.channel.call("log.web.text.input", webTextInput);
    }

    async logWebNavigationSessions(webNavigationSessions: WebNavigationSessionDataDTO[]): Promise<void> {
        await this.channel.call("log.web.navigation.sessions", webNavigationSessions);
    }

    async logYoutubeWatchSessions(youtubeWatchSessions: YoutubeWatchSessionDataDTO[]): Promise<void> {
        await this.channel.call("log.youtube.watch.sessions", youtubeWatchSessions);
    }

    async forwardWebRTCSignaling(webRTCSessionId: string, signalingType: string, payload: any): Promise<void> {
        await this.channel.call("forward.web.rtc.signaling", webRTCSessionId, signalingType, payload);
    }

    async queryYoutubeVideo(videoId: string): Promise<YoutubeVideo> {
        const youtubeVideo: YoutubeVideo = (await this.channel.call("query.youtube.video", videoId)) as YoutubeVideo;
        return youtubeVideo;
    }

    async queryYoutubeChannelId(channelId: string): Promise<YoutubeChannel> {
        const youtubeChannel: YoutubeChannel = (await this.channel.call("query.youtube.channel.id", channelId)) as YoutubeChannel;
        return youtubeChannel;
    }

    async queryYoutubeChannelHandle(handle: string): Promise<YoutubeChannel> {
        const youtubeChannel: YoutubeChannel = (await this.channel.call("query.youtube.channel.handle", handle)) as YoutubeChannel;
        return youtubeChannel;
    }
}
